#import "../fragments/product-category-fragment.graphql"

mutation ProductCategoryCreate($input: ProductCategoryCreateInput!) {
    productCategoryCreate(input: $input) {
        productCategory {
            ...ProductCategoryFragment
        }
    }
}
